export default "__VITE_ASSET__rU4uIku2__"